import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function getCarerStudents(payload) {
  return { type: actionTypes.FETCH_CARER_STUDENTS, payload };
}
export function getCarerStudentsSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (payload) => {
    return index++;
  });
  return { type: actionTypes.FETCH_CARER_STUDENTS_SUCCESS, payload: { byId } };
}

export function getStudentLearningBehaviourByCourse(payload) {
  console.log('PAYLOAD 1', payload);
  return {
    type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE,
    payload,
  };
}

export function getStudentLearningBehaviourByCourseSuccess(payload1) {
  const series = [];
  let payload = [...payload1]
  console.log('PAYLOAD 2', payload);


  payload.forEach((el) => {
    const exisitingSubject = series.findIndex((e) => e.title === el['SUBJECT']);
    const seri = {
      title: el['SUBJECT'],
      data: exisitingSubject !== -1 ? series[exisitingSubject].data : {},
    };
    series.push()
    Object.keys(el)
      .filter((c) => c !== 'SUBJECT' && c !== 'USERNAME')
      .forEach((z) => {
        if (!seri.data[z]) {
          seri.data[z] = el[z];
        }
      });
    if (exisitingSubject !== -1) {
      series[exisitingSubject] = seri;
    } else {
      series.push(seri);
    }
  });
  console.log(series);
  return {
    type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_SUCCESS,
    payload: {
      series,
    },
  };
}

export function getPlotCourses(payload) {
  return { type: actionTypes.GET_PLOT_COURSES, payload };
}

export function getPlotCoursesSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return { type: actionTypes.GET_PLOT_COURSES_SUCCESS, payload: { byId } };
}

export function getPlotTask(payload) {
  return { type: actionTypes.GET_PLOT_TASK, payload };
}

export function getPlotTaskSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return { type: actionTypes.GET_PLOT_TASK_SUCCESS, payload: { byId } };
}

export function getStudentAcademicReposts(payload) {
  return { type: actionTypes.GET_STUDENT_ACADEMIC_REPORT, payload };
}

export function getStudentAcademicRepostsSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return {
    type: actionTypes.GET_STUDENT_ACADEMIC_REPORT_SUCCESS,
    payload: { byId },
  };
}

export function getStudentAbsenceSummary(payload) {
  return { type: actionTypes.GET_STUDENT_ABSENCE_SUMMARY, payload };
}

export function getStudentAbsenceSummarySuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return {
    type: actionTypes.GET_STUDENT_ABSENCE_SUMMARY_SUCCESS,
    payload: { byId },
  };
}

export function getStudentLearningBehaviour(payload) {
  return { type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR, payload };
}

export function getStudentLearningBehaviourSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return {
    type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_SUCCESS,
    payload: { byId },
  };
}

export function getStudentLearningGoals(payload) {
  return { type: actionTypes.GET_STUDENT_LEARNING_GOALS, payload };
}
export function getStudentLearningGoalsSuccess(payload) {
  let index = 0;
  const byId = keyBy(payload, (course) => {
    return index++;
  });
  return {
    type: actionTypes.GET_STUDENT_LEARNING_GOALS_SUCCESS,
    payload: { byId },
  };
}

export function getHomeRoomComments(payload) {
  return {
    type: actionTypes.GET_HOME_ROOM_COMMENTS,
    payload,
  };
}

export function getHomeRoomCommentsSuccess(payload) {
  console.log('payload........', payload)
  let index = 0;
  const byId = keyBy(payload, (comment) => {
    return index++;
  });
  console.log('byId........', byId)
  return {
    type: actionTypes.GET_HOME_ROOM_COMMENTS_SUCCESS,
    payload: { byId },
  };
}

//Init Action
export function getStudentList(payload) {
  return { type: actionTypes.GET_STUDENT_LIST, payload };
}

//Success Action
export function getStudentListSuccess(payload) {
  let index = 0;
  const listData = keyBy(payload, (comment) => {
    return index++;
  })
  return {
    type: actionTypes.GET_STUDENT_LIST_SUCCESS,
    payload: { listData }
  }
}

export function appendStudentArray(payload) {
  return { type: actionTypes.APPEND_STUDENT_ARRAY, payload };
}

//Init Action
export function getStudentNotes(payload) {
  return { type: actionTypes.FETCH_STUDENT_NOTES, payload };
}

//Success Action
export function getStudentNotesSuccess(payload) {
  let index = 0;
  const notes = keyBy(payload, (comment) => {
    return index++;
  })
  return {
    type: actionTypes.FETCH_STUDENT_NOTES_SUCCESS,
    payload: { notes }
  }
}



export function sendStudentNote(payload) {
  return { type: actionTypes.SEND_STUDENT_NOTE, payload };
}
export function sendStudentNoteSuccess(payload) {
  return { type: actionTypes.SEND_STUDENT_NOTE_SUCCESS, payload };
}
